import { ToneEvenCardCSSStyleImpl } from '../../home/featuredcategory/viewmodel/tonecard/toneevencardcssstyle';

export class NameTuneEvenCardCSSStyleImpl extends ToneEvenCardCSSStyleImpl 
{
   
    // getToneWrapperCSSStyle(marginTop: string): object
    // {
    //     return {
    //         height: '280px', 
    //         width: '262px', 
    //         marginRight: "40px",
    //         marginTop: marginTop,
    //         objectFit: 'cover', 
    //         position: 'relative',
    //         cursor: "pointer",
    //         borderRadius:'0px 50px 0px 50px'
    //     };
    // }

    // getOnHoverCSSStyle(): object 
    // {
    //     return {
    //         objectFit: 'cover', 
    //         position: 'absolute',
    //         height: '280px', 
    //         width: '262px', 
    //         borderRadius:'0px 50px 0px 50px',
    //         display: "flex",
    //         paddingLeft: "20px",
    //         paddingRight: "20px",
    //         paddingTop: "20px",
    //         opacity:'0.75',
    //         backgroundColor:"#003187"
    //         // background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
    //     };

    // } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunecard/nametuneevencardcss.tsx